import { Injectable } from "@angular/core";
import { CompanyInterface, CompanyServiceAbstract } from "@mare-common/ngx-mare-user";
import { UserCompanyService } from "./userCompany.service";
import { Subject } from "rxjs";
import { TokenService } from "./token.service";

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends CompanyServiceAbstract {

  retriveCompanyPromise: Promise<CompanyInterface | null> | null = null;

  company$: Subject<CompanyInterface | null> = new Subject<CompanyInterface | null>();
  userCompanySub: any;

  constructor(
    protected userCompanyService: UserCompanyService,
    private tokenService: TokenService
  ) {
    super();
    this.init();

    this.userCompanySub = this.userCompanyService.userCompany$.subscribe((userCompany: any) => {
      this.company = userCompany.company;
      this.company$.next(userCompany.company);
    });

  }

  override retrieveCompany(forceReload?: boolean | undefined): Promise<CompanyInterface | null> {
    if (this.retriveCompanyPromise) {
      return this.retriveCompanyPromise;
    }
    this.retriveCompanyPromise = new Promise<CompanyInterface | null>((resolve, reject) => {
      if (this.company) {
        resolve(this.company);
        setTimeout(() => {
          this.retriveCompanyPromise = null;
        }, 50);
        return;
      }
      let loggedSub = this.tokenService.loggedSignal.subscribe((logged: boolean) => {
        if (logged) {
          this.userCompanyService.retrieveUserCompany(forceReload)
            .catch((err: any) => {
              reject(err);
              setTimeout(() => {
                this.retriveCompanyPromise = null;
              }, 50);
              return err;
            })
            .then((companyCompany: any) => {
              if (!companyCompany) {
                reject(null);
                return;
              }
              resolve(companyCompany.company);
              this.company$.next(companyCompany.company);
              setTimeout(() => {
                this.retriveCompanyPromise = null;
              }, 50);
            }).finally(() => {
              loggedSub.unsubscribe();
            })
        }
      });
    });
    return this.retriveCompanyPromise;
  }

}